import organizationApi from '@/api/organization';

const state = {
    list: null,
    fullList: null,
    organizationCreated: null,
    organizationUpdated: null,
    isLoading: false,
    validationErrors: null,
    managersList:null,
    organization:null
}

export const mutationTypes = {
    organizationListStart: '[organization] List organization start',
    organizationListSuccess: '[organization] List organization success',
    organizationListFailure: '[organization] List organization failure',

    organizationFullListStart: '[organization] Full list organization start',
    organizationFullListSuccess: '[organization] Full list organization success',
    organizationFullListFailure: '[organization] Full list organization failure',

    organizationCreateStart: '[organization] Create organization start',
    organizationCreateSuccess: '[organization] Create organization success',
    organizationCreateFailure: '[organization] Create organization failure',

    organizationUpdateStart: '[organization] Update organization start',
    organizationUpdateSuccess: '[organization] Update organization success',
    organizationUpdateFailure: '[organization] Update organization failure',

    organizationManagersListStart: '[organization] Managers list organization start',
    organizationManagersListSuccess: '[organization] Managers list organization success',
    organizationManagersListFailure: '[organization] Managers list organization failure',

    organizationInfoStart: '[organization] Organization info start',
    organizationInfoSuccess: '[organization] Organization info success',
    organizationInfoFailure: '[organization] Organization info failure',

}

export const organizationActionTypes = {
    organizationList: '[organization] List organization',
    organizationFullList: '[organization] Full list organization',
    organizationCreate: '[organization] Create organization',
    organizationUpdate: '[organization] Update organization',
    organizationManagersList: '[organization] Managers list organization',
    organizationInfo: '[organization] Organization info'
}

const mutations = {
    [mutationTypes.organizationListStart](state) {
        state.isLoading = true
        state.list = null
    },
    [mutationTypes.organizationListSuccess](state, payload) {
        state.isLoading = false
        state.list = payload
        state.validationErrors = null
    },
    [mutationTypes.organizationListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.organizationFullListStart](state) {
        state.isLoading = true
        state.fullList = null
    },
    [mutationTypes.organizationFullListSuccess](state, payload) {
        state.isLoading = false
        state.fullList = payload
        state.validationErrors = null
    },
    [mutationTypes.organizationFullListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.organizationCreateStart](state) {
        state.isLoading = true
        state.organizationCreated = null
    },
    [mutationTypes.organizationCreateSuccess](state, payload) {
        state.isLoading = false
        state.organizationCreated = payload
        state.validationErrors = null
    },
    [mutationTypes.organizationCreateFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.organizationUpdateStart](state) {
        state.isLoading = true
        state.organizationUpdated = null
    },
    [mutationTypes.organizationUpdateSuccess](state, payload) {
        state.isLoading = false
        state.organizationUpdated = payload
        state.validationErrors = null
    },
    [mutationTypes.organizationUpdateFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.organizationManagersListStart](state) {
        state.isLoading = true
        state.managersList = null
    },
    [mutationTypes.organizationManagersListSuccess](state, payload) {
        state.isLoading = false
        state.managersList = payload
        state.validationErrors = null
    },
    [mutationTypes.organizationManagersListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.organizationInfoStart](state) {
        state.isLoading = true
        state.organization = null
    },
    [mutationTypes.organizationInfoSuccess](state, payload) {
        state.isLoading = false
        state.organization = payload
        state.validationErrors = null
    },
    [mutationTypes.organizationInfoFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    
}

const actions = {
    [organizationActionTypes.organizationList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.organizationListStart)
            organizationApi
                .organizationList(data)
                .then(response => {
                    context.commit(mutationTypes.organizationListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.organizationListFailure,response)
                })
        })
    },
    [organizationActionTypes.organizationFullList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.organizationFullListStart)
            organizationApi
                .organizationFullList(data)
                .then(response => {
                    context.commit(mutationTypes.organizationFullListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.organizationFullListFailure,response)
                })
        })
    },
    [organizationActionTypes.organizationCreate](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.organizationCreateStart)
            organizationApi
                .organizationCreate(data)
                .then(response => {
                    context.commit(mutationTypes.organizationCreateSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.organizationCreateFailure,response)
                })
        })
    },
    [organizationActionTypes.organizationUpdate](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.organizationUpdateStart)
            organizationApi
                .organizationUpdate(data)
                .then(response => {
                    context.commit(mutationTypes.organizationUpdateSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.organizationUpdateFailure,response)
                })
        })
    },

    [organizationActionTypes.organizationManagersList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.organizationManagersListStart)
            organizationApi
                .managersList(data)
                .then(response => {
                    context.commit(mutationTypes.organizationManagersListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.organizationManagersListFailure,response)
                })
        })
    },

    [organizationActionTypes.organizationInfo](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.organizationInfoStart)
            organizationApi
                .organizationInfo(data)
                .then(response => {
                    context.commit(mutationTypes.organizationInfoSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.organizationInfoFailure,response)
                })
        })
    },
}

export default {
    state,
    actions,
    mutations
}